import { ProjectTimelineActionType } from '../actionTypes/projectTimeline';
import { PostDispatch } from '../types';

const ProjectTimelineReducer = (state = null, action: PostDispatch) => {
    switch (action.type) {
        case ProjectTimelineActionType.GET_PROJECT_TIMELINE:
        case ProjectTimelineActionType.SAVE_PROJECT_TIMELINE:
            return action.payload;
        default:
            return state;
    }
};

export default ProjectTimelineReducer;
